import { beSmsAliasGetSMSList } from 'Api/beSmsAlias'
import getIntl from 'Helpers/intl'
import { MESSAGE_BOX_VARIANT_DANGER } from 'mailup-web-components'
import { useEffect } from 'react'
import { atom, useRecoilCallback, useRecoilState } from 'recoil'

export async function getSMSAliasList() {
  const result = await beSmsAliasGetSMSList()
  return result
}

export const modalSmsSenderState = atom({
  key: 'modalSmsSenderState',
  default: {
    items: undefined,
    loading: true,
    loaded: false,
    error: false,
    errMessage: '',
    severity: MESSAGE_BOX_VARIANT_DANGER,
    selectedAlias: undefined
  }
})

const useModalSmsSender = () => {
  const [{ items, loaded, loading, error, errMessage, severity }, setState] =
    useRecoilState(modalSmsSenderState)

  const initCallback = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        try {
          const itemList = await getSMSAliasList()
          setState((prev) => ({
            ...prev,
            items: itemList
          }))
        } catch (error) {
          setState((prev) => ({
            ...prev,
            error: true,
            errMessage: getIntl().formatMessage({
              id: 'Load.Alerts.ErrorGeneric'
            }),
            severity: MESSAGE_BOX_VARIANT_DANGER
          }))
        }

        setState((prev) => ({
          ...prev,
          loading: false,
          loaded: true
        }))
      },
    []
  )

  useEffect(() => {
    initCallback()
  }, [])

  return {
    items,
    loaded,
    loading,
    error,
    errMessage,
    severity
  }
}

export default useModalSmsSender
